import { render, staticRenderFns } from "./ListTextos.vue?vue&type=template&id=1222f22a"
import script from "./ListTextos.vue?vue&type=script&lang=js"
export * from "./ListTextos.vue?vue&type=script&lang=js"
import style0 from "./ListTextos.vue?vue&type=style&index=0&id=1222f22a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports